/* global VXBannerConfig */
import React          from 'react';
import PropTypes      from 'prop-types';
import Block          from './../Block';
import ActionProvider from '../../VXTeaser/ActionProvider';
import {BannerSuite}  from 'vxteaser';

class TeaserBlock extends React.Component {
	render() {
		const bannerConfig = VXBannerConfig && VXBannerConfig[this.props.teaserContext];

		if (!bannerConfig) {
			return null;
		}

		return (
			<Block className='teasers has-no-border'>
				<ActionProvider>
					<BannerSuite configs={bannerConfig}
				                 autoplaySpeed={10000}
				                 arrows={false}
				                 dots={true}
				    />
				</ActionProvider>
			</Block>
		);
	}
}

TeaserBlock.propTypes = {
	teaserContext: PropTypes.string.isRequired,
};

export default TeaserBlock;
